import {apiGet} from "../apiService";

export async function loadPermissionsOnce() {
    const loaded = localStorage.getItem("permissionsLoaded");
    const token = localStorage.getItem("authToken");

    if (!token) return false;

    if (loaded) return true;

    try {
        const res = await apiGet("user", "/modules/sidebar");
        if (res?.status === "success") {
            localStorage.setItem("permissions", JSON.stringify(res.data));
            localStorage.setItem("permissionsLoaded", "true");
            return true;
        }
    } catch (e) {
        console.error("Permission load failed", e);
    }

    return false;
}
